import { gql } from 'apollo-angular';

export const deleteRateFromTheProject = gql`
  mutation deleteProjectWageRatesLegacy(
    $rateIds: [UUID!]!
    $legacyProjectId: Int!
    $tenantId: UUID!
  ) {
    deleteProjectWageRatesLegacy(
      rateIds: $rateIds
      legacyProjectId: $legacyProjectId
      tenantId: $tenantId
    ) {
      data {
        deleted
      }
      errors {
        message
        extensions {
          attemptedValue
          errorCode
          propertyName
          severity
        }
      }
    }
  }
`;
